import React from "react";
import toLower from "lodash/toLower";
import trim from "lodash/trim";

import { validateLogin } from "@shared/lib/validateWithYup";

import FormContainer from "@ats/src/components/forms/FormContainer";
import SessionFormInput from "@ats/src/views/sessions/components/SessionFormInput";
import SessionButton from "@ats/src/views/sessions/components/SessionButton";

import { useLogin } from "@shared/queryHooks/useSession";

function LoginForm(props) {
  const [state, setState] = React.useState({
    email: "",
    password: "",
    errors: [],
  });

  const { mutate: login, isLoading } = useLogin();
  const { email, password, errors } = state;

  const handleInputChange = (name, value) => {
    setState({ ...state, [name]: value, errors: null });
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    // Trim email and update state
    const trimmedEmail = email.trim();
    setState({ ...state, email: trimmedEmail });

    const [isValid, validationErrors] = await validateLogin({ email: trimmedEmail, password });

    if (isValid) {
      login(
        { email: trim(toLower(trimmedEmail)), password },
        {
          onSuccess: (data) => {
            window.logger("[LoginForm] data", data);
            props.onComplete();
          },
          onError: (response: any) => {
            window.logger("[LoginForm] server error", { response });
            // Handles Devise Errors
            if (response.data.error) {
              setState({ ...state, errors: [response.data.error] });
            }
            // Handles non Devise Errors
            if (response.data.errors) {
              setState({ ...state, errors: response.data.errors });
            }
          },
        },
      );
    } else {
      window.logger("[LoginForm] errors", { validationErrors });
      setState({ ...state, errors: validationErrors });
    }
  };

  return (
    <FormContainer
      onSubmit={handleLogin}
      errors={errors}
      buttons={
        <SessionButton type="submit" disabled={isLoading} loading={isLoading}>
          Log in
        </SessionButton>
      }
    >
      <SessionFormInput
        onChange={handleInputChange}
        name="email"
        placeholder=""
        label="Email"
        className=""
        errors={errors}
      />

      <SessionFormInput
        onChange={handleInputChange}
        name="password"
        placeholder=""
        label="Password"
        className=""
        inputType="password"
        errors={errors}
      />
    </FormContainer>
  );
}

export default LoginForm;
